<div class="card" id="contact-gps-devices">
    <div class="card-body">
        <div class="title-bar">
            <h2 class="card-title">Tracking Devices</h2>
        </div>
    </div>
    <ul class="list-group list-group-flush gps-device-list">
        @for (device of devices; track device.id) {
            <li class="list-group-item" (click)="selected($event, device)">
                @if (!device.vehicleUrl) {
                    <span class="material-icons" title="{{device.stock}} {{device.vehicle}} {{device.vin}}">directions_car</span>
                }
                @if (device.vehicleUrl) {
                    <img class="d-none d-xl-block" [src]="device.vehicleUrl" />
                }
                <div class="text-truncate">
                    <p class="title"><a href="{{device.companyUrl}}" target="_blank">{{device.company}}</a> {{device.product | titlecase}} installed by {{device.installer}} ({{device.location}})</p>
                    @if (device.notes && (device.notes.length > 0)) {
                        <p class="subtitle">{{device.notes}}</p>
                    }
                    @else {
                        <p class="subtitle">{{device.stock}} {{device.vehicle}} {{device.vin}}</p>
                    }

                    @if (device.expires) {
                        <p class="{{expiryClass(device.expires)}} subtitle">expires {{device.expires | date:'E MMM d, yyyy'}}</p>
                    }
                </div>
                <span class="material-icons" (click)="locate($event, device)">place</span>
            </li>
        }
        @empty {
            <li class="list-group-item">No tracking devices installed at this time.</li>
        }
    </ul>
</div>